// Utility functions for managing dynamic page titles

const SITE_NAME = "Alwi Al-haddad - Full Stack Developer";

/**
 * Generate a formatted page title
 * @param {string} pageTitle - The specific page title
 * @param {boolean} includeSiteName - Whether to include site name (default: true)
 * @returns {string} - Formatted title
 */
export const getPageTitle = (pageTitle, includeSiteName = true) => {
  if (!pageTitle) {
    return SITE_NAME;
  }
  
  return includeSiteName ? `${pageTitle} - ${SITE_NAME}` : pageTitle;
};

/**
 * Generate a blog post title
 * @param {string} postTitle - The blog post title
 * @returns {string} - Formatted blog title
 */
export const getBlogTitle = (postTitle) => {
  return getPageTitle(postTitle);
};

/**
 * Generate a project title
 * @param {string} projectTitle - The project title
 * @returns {string} - Formatted project title
 */
export const getProjectTitle = (projectTitle) => {
  return getPageTitle(projectTitle);
};

/**
 * Truncate description for meta tags
 * @param {string} description - The description text
 * @param {number} maxLength - Maximum length (default: 160)
 * @returns {string} - Truncated description
 */
export const getMetaDescription = (description, maxLength = 160) => {
  if (!description) {
    return "Alwi Al-haddad - Full Stack Developer specializing in React, TypeScript, and Machine Learning. UCL Biomedical Engineering graduate creating innovative web solutions and AI applications.";
  }
  
  if (description.length <= maxLength) {
    return description;
  }
  
  // Truncate at word boundary
  const truncated = description.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  
  return lastSpace > 0 
    ? truncated.substring(0, lastSpace) + '...'
    : truncated + '...';
};
